import { render, staticRenderFns } from "./TipsPage.vue?vue&type=template&id=2a5449a9&scoped=true&"
import script from "./TipsPage.vue?vue&type=script&lang=js&"
export * from "./TipsPage.vue?vue&type=script&lang=js&"
import style0 from "./TipsPage.vue?vue&type=style&index=0&id=2a5449a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5449a9",
  null
  
)

export default component.exports